import React, { useState } from "react";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    city: "",
    message: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSendQuery = (e) => {
    e.preventDefault();

    const phoneNumber = "9829326555";
    const { name, email, mobile, message } = formData;

    if (!name || !email || !mobile) {
      alert("Please fill in all required fields.");
      return;
    }

    const whatsappMessage = `LUSORA - New Query:\nHello, I am ${name}.\nMobile: ${mobile}\nEmail: ${email}\nMessage: ${message || "No message provided."}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, "_blank");

    setIsSubmitted(true);
    setFormData({ name: "", email: "", mobile: "", city: "", message: "" });
    setTimeout(() => setIsSubmitted(false), 3000);
  };

  return (
    <section className="contact-wrapper">
      <div className="contactus"></div>
      <h2 className="contact-title">Contact Us</h2>
      <p className="contact-subtext">We’re here to help! Send us your queries.</p>

      <div className="contact-container">
        {/* Form Section */}
        <div className="contact-form-box">
          <form className="contact-form" onSubmit={handleSendQuery}>
            <div className="form-group">
              <label htmlFor="name">Name <span>*</span></label>
              <input type="text" id="name" placeholder="Enter your name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="email">E-mail <span>*</span></label>
              <input type="email" id="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="mobile">Mobile <span>*</span></label>
              <input type="tel" id="mobile" placeholder="Enter your mobile number" value={formData.mobile} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label htmlFor="city">City</label>
              <input type="text" id="city" placeholder="Enter your city" value={formData.city} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" rows="4" placeholder="Write your message" value={formData.message} onChange={handleChange}></textarea>
            </div>
            <button type="submit" className="contact-btn">SEND</button>
          </form>
          {isSubmitted && <div className="contact-popup">Your query has been sent!</div>}
        </div>

        {/* Contact Details Section */}
        <div className="contact-info-box">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.9883431639905!2d75.73863077489248!3d26.840323063198678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5b4274ad7d5%3A0xbb754b216657831!2sLusora%20Food%20and%20Beverage!5e0!3m2!1sen!2sin!4v1743533999042!5m2!1sen!2sin"
          width="100%"
          height="400"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
          <div className="contact-details">
            <h2>Lusora Food and Beverages</h2>
            <p><strong>Registered Office:</strong> 242, Patrakar Colony, Mansarovar, Jaipur, Rajasthan 302020</p>
            <p><strong>Contact:</strong> Mob: 9829326555, 9057505529</p>
            <p><strong>Email:</strong> <a className="mail" href="mailto:sales@lusora.in">sales@lusora.in</a></p>
          </div>
        </div>

        {/* <div className="contact-info-box">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?..."
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          <div className="contact-details">
            <h2>Tax O Wealth Advisors</h2>
            <p><strong>Registered Office:</strong> 242, Patrakar Colony Mansarovar, Jaipur, Rajasthan, 302020</p>
            <p><strong>Contact:</strong> Mob: 94131-88887, 90575-05529</p>
            <p><strong>Email:</strong> <a className="mail" href="mailto:info@lusora.com">info@lusora.com</a></p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ContactUs;
